import * as React from 'react';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import NotFound from 'bundles/phoenix/components/NotFound';

import 'css!bundles/about/components/styl/AboutApp';

export default function AboutApp({ children }: { children: React.ReactNode }) {
  return (
    <div className="rc-AboutApp coursera-body">
      <PageHeader
        hideSearch
        hideEnterprise
        shouldSkipOptionalExternalDataFetch={true}
        showLanguagesDropdown={false}
        hideMetaNav={true}
      />
      <div className="bt3-container c-about-canvas-container" role="main">
        <div className="coursera-full-canvas">
          <div className="coursera-about-body">{children || <NotFound />}</div>
        </div>
      </div>
      <PageFooter />
    </div>
  );
}
